import * as R from "ramda";
import { isFrequencyDimension } from "./isFrequencyDimension.mjs";
import { isFrequencyAttribute } from "./isFrequencyAttribute.mjs";
import { SUPPORTED_FORMAT } from "./constants/frequency.mjs";
const getFrequencyArtefact = ({ dimensions, attributes }) => {
  const frequencyDimension = R.find(isFrequencyDimension, dimensions);
  if (!R.isNil(frequencyDimension)) {
    return frequencyDimension;
  }
  const frequencyAttribute = R.find(isFrequencyAttribute, attributes);
  if (R.isNil(frequencyAttribute) || R.pipe(R.propOr([], "values"), R.isEmpty)(frequencyAttribute)) {
    return void 0;
  }
  const timeFormatAttribute = R.pipe(
    R.over(
      R.lensProp("values"),
      R.reduce((acc, valueItem) => {
        const id = R.prop(valueItem.id, SUPPORTED_FORMAT);
        if (R.isNil(id)) return acc;
        return R.append(R.assoc("id", id, valueItem), acc);
      }, [])
    ),
    R.dissoc("index"),
    R.assoc("isAttribute", true)
  )(frequencyAttribute);
  if (R.isEmpty(timeFormatAttribute.values)) return void 0;
  return timeFormatAttribute;
};
export {
  getFrequencyArtefact
};
